module.exports = __webpack_public_path__ + "static/media/Vibelog.157b6d9e.png";